import { makeCloudFunction } from "../makeCloudFunction";
import { SearchSpacesRequest, SearchSpacesResponse } from "@functions-types";

export const searchSpaces = makeCloudFunction<
  SearchSpacesRequest,
  SearchSpacesResponse
>("space", "searchSpaces");
